module.exports = __webpack_public_path__ + "static/media/24_shape_r.51ed4478.webp";